import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react"; 
import { Navigation } from "swiper"; 
import "swiper/css";
import "swiper/css/navigation"; 
import VaultCard from "./VaultCard"; 
import { Link } from "react-router-dom"; 

const CardSlider = ({ tokens, cards, heading }) => {
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const handleSlideChange = (swiper) => {
    setActiveSlideIndex(swiper.realIndex);
  };

  const handleBulletClick = (index) => {
    if (swiperInstance) {
      swiperInstance.slideTo(index);
    }
  };

  return (
    <div className="exchange">
      <div className="slider-container">
        {/* Left Slider */}
        <div className="left-slider">
          <div className="top">
            {/* Top Gainers Heading */}
            <h2 id="topGainersHeading">Top Gainers</h2>
          </div>
          <div className="bottom">
            {cards.length === 0 ? (
              <p className="no-data-message">No data found</p>
            ) : (
              <Swiper
                slidesPerView={3}
                spaceBetween={30}
                freeMode={true}
                navigation={true}
                modules={[Navigation]}
                breakpoints={{
                  320: { slidesPerView: 1, spaceBetween: 15 },
                  480: { slidesPerView: 1, spaceBetween: 15 },
                  768: { slidesPerView: 2, spaceBetween: 10 },
                  1080: { slidesPerView: 3, spaceBetween: 10 },
                }}
                onSwiper={setSwiperInstance}
                onSlideChange={handleSlideChange}
                className="mySwiper1"
              >
                {cards.map((card, index) => (
                  <SwiperSlide key={index}>
                    <VaultCard item={card} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
            
            <div className="custom-pagination">
              {cards.map((_, index) => (
                <span
                  key={index}
                  className={`pagination-bullet ${activeSlideIndex === index ? "active" : ""}`}
                  onClick={() => handleBulletClick(index)}
                ></span>
              ))}
            </div>
          </div>
        </div>

        {/* Right Slider */}
        <div className="right-slider">
          <div className="top">
            <Link to="/detail-view">
              <h2>New Pools</h2>
            </Link>
          </div>
          <div className="bottom">
            {tokens.length === 0 ? (
              <p className="no-data-message">No data found</p>
            ) : (
              <Swiper
                slidesPerView={3}
                spaceBetween={30}
                freeMode={true}
                navigation={true}
                modules={[Navigation]}
                breakpoints={{
                  320: { slidesPerView: 1, spaceBetween: 15 },
                  480: { slidesPerView: 1, spaceBetween: 15 },
                  768: { slidesPerView: 2, spaceBetween: 10 },
                  1080: { slidesPerView: 3, spaceBetween: 10 },
                }}
                className="mySwiper2"
              >
                {tokens.map((token, index) => (
                  <SwiperSlide key={index}>
                    <VaultCard item={token} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
            <div className="custom-pagination">
              {tokens.map((_, index) => (
                <span
                  key={index}
                  className={`pagination-bullet ${activeSlideIndex === index ? "active" : ""}`}
                  onClick={() => handleBulletClick(index)}
                ></span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardSlider;






// import React, { useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react"; 
// import { Autoplay, A11y, Navigation } from "swiper"; 
// import "swiper/css";
// import "swiper/css/navigation"; 
// import VaultCard from "./VaultCard"; 
// import { Link } from "react-router-dom"; 

// const CardSlider = ({ tokens, cards, heading }) => {
//   const [activeSlideIndex, setActiveSlideIndex] = useState(0);
//   const [swiperInstance, setSwiperInstance] = useState(null);

//   const handleSlideChange = (swiper) => {
//     setActiveSlideIndex(swiper.realIndex);
//   };

//   const handleBulletClick = (index) => {
//     if (swiperInstance) {
//       swiperInstance.slideTo(index);
//     }
//   };

//   return (
//     <div className="exchange">
//       <div className="slider-container">
//         {/* Left Slider */}
//         <div className="left-slider">
//           <div className="top">
//             {/* Top Gainers Heading */}
//             <h2 id="topGainersHeading">Top Gainers</h2>
//           </div>
//           <div className="bottom">
//             <Swiper
//               slidesPerView={3}
//               spaceBetween={30}
//               freeMode={true}
//               navigation={true}
//               modules={[Navigation]}
//               breakpoints={{
//                 320: { slidesPerView: 1, spaceBetween: 15 },
//                 480: { slidesPerView: 1, spaceBetween: 15 },
//                 768: { slidesPerView: 2, spaceBetween: 10 },
//                 1080: { slidesPerView: 3, spaceBetween: 10 },
//               }}
//               onSwiper={setSwiperInstance}
//               onSlideChange={handleSlideChange}
//               className="mySwiper1"
//             >
//               {cards.map((card, index) => (
//                 <SwiperSlide key={index}>
//                   <VaultCard item={card} />
//                 </SwiperSlide>
//               ))}
//             </Swiper>
            
//             <div className="custom-pagination">
//               {cards.map((_, index) => (
//                 <span
//                   key={index}
//                   className={`pagination-bullet ${activeSlideIndex === index ? "active" : ""}`}
//                   onClick={() => handleBulletClick(index)}
//                 ></span>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Right Slider */}
//         <div className="right-slider">
//           <div className="top">
//             <Link to="/detail-view">
//               <h2>New Pools</h2>
//             </Link>
//           </div>
//           <div className="bottom">
//             <Swiper
//               slidesPerView={3}
//               spaceBetween={30}
//               freeMode={true}
//               navigation={true}
//               modules={[Navigation]}
//               breakpoints={{
//                 320: { slidesPerView: 1, spaceBetween: 15 },
//                 480: { slidesPerView: 1, spaceBetween: 15 },
//                 768: { slidesPerView: 2, spaceBetween: 10 },
//                 1080: { slidesPerView: 3, spaceBetween: 10 },
//               }}
//               className="mySwiper2"
//             >
//               {tokens.map((token, index) => (
//                 <SwiperSlide key={index}>
//                   <VaultCard item={token} />
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//             <div className="custom-pagination">
//               {tokens.map((_, index) => (
//                 <span
//                   key={index}
//                   className={`pagination-bullet ${activeSlideIndex === index ? "active" : ""}`}
//                   onClick={() => handleBulletClick(index)}
//                 ></span>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CardSlider;